import React from 'react'
import BootstrapTable from "react-bootstrap-table-next";
import {connect} from "react-redux";


// component
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";

// labels
import {NO_DATA_FOUND} from "../../../../components/i18n/i18n";
import {TT_DELETE, TT_SEND_ALERT} from "../../../../components/i18n/toolTips";

// actions
import {remove} from "../../../../redux/actions/comunication/notificationActivityActions"
import {sendAlert} from "../../../../redux/actions/comunication/notificationActions"

const NotificationsList = props => {
     const { notifications, remove, onClose, activity } = props
    const { app } = props.mainProps;
    const fbDataBase = { id: app?.fbDataBase?.id }


    const sendAlert = notification => {
        const requestData = {
            header: { app: props.mainProps?.app?.id},
            item:{ id: notification?.id}
        }

        props.sendAlert(requestData)
        onClose()
    }


    const removeNotification = data => {
         const requestData = {
             fbDataBase,
             item: {
                 activityID: activity?.id,
                 notificationID: data?.id
             }
         }

        remove( requestData )
        onClose()
    }

    const actionsFormatter = (cell, row) => <>
        <GenericTableButton
            toolTip={TT_SEND_ALERT}
            icon={'fa fa-paper-plane-o'}
            permission={'edit'}
            onClick={() => sendAlert(row)}
        />
        <GenericTableButton
            toolTip={TT_DELETE}
            icon={'fa-trash'}
            permission={'delete'}
            onClick={() => removeNotification(row)}
        />
    </>

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            headerStyle: {width: '0px'},
            hidden: true
        }, {
            dataField: 'title',
            headerStyle: {width: '300px'},
            text: 'Título'
        }, {
            dataField: 'body',
            headerStyle: {width: '500px'},
            text: 'Cuerpo'
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '200px'},
            formatter: actionsFormatter
        }
    ]

    return <BootstrapTable
        striped hover
        tableHeaderClass='mb-0'
        remote
        keyField="id"
        data={ notifications }
        columns={columns}
        noDataIndication={NO_DATA_FOUND}
    />
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
})

const mapActionsToProps = ({ remove, sendAlert })
export default connect(mapStateToProps, mapActionsToProps)(NotificationsList)